import React, { useEffect } from "react";

interface LoadingProps {
    isLoading: boolean;
}

const WidgetLoader: React.FC<LoadingProps> = ({ isLoading }) => {
    useEffect(() => {
        if (isLoading) {
            document.body.style.overflow = "hidden";
            document.body.style.height = "100%";
        } else {
            document.body.style.overflow = "";
            document.body.style.height = "";
        }
        return () => {
            document.body.style.overflow = "";
            document.body.style.height = "";
        };
    }, [isLoading]);

    return (
        <>
            {isLoading && (
                <div className="flex justify-center items-center h-full w-full">
                    <div className="animate-spin rounded-full h-10 w-10 border-b-4 border-darkcolor-400"></div>
                </div>
            )}
        </>
    );
};

export default WidgetLoader;
